import baseUrl from "../config/baseUrl";

const permanentlyDeleteCategory = async ({ token, id }) => {
  try {
    const response = await fetch(
      `${baseUrl}/DMS/api/permanentcategoriesdelete/${id}`,
      {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default permanentlyDeleteCategory;
